import { getGtmData } from '..';

const login = () => ({
  loginPageLoad: () => {
    // recordEventWrapper({
    //   event: 'event_PFM_on_page_load_vpv',
    //   page: 'vpv/pfm/online-investments/login/mpin',
    //   title: 'PFM - Online Investments - Login - mPIN',
    // });
  },
  forgetCustomerId: (pageName: string) => {
    // recordEventWrapper({
    //   event: 'event_PFM_on_click_event',
    //   category: 'PFM',
    //   action: 'Online Investments',
    //   label: `Login - Landing Screen - ${pageName} - Forgot Customer ID`,
    // });
  },
  forgetPassword: () => {
    // recordEventWrapper({
    //   event: 'event_PFM_on_click_event',
    //   category: 'PFM',
    //   action: 'Online Investments',
    //   label: 'Login - Landing Screen - Net Banking - Forgot Password',
    // });
  },
  onClickMpinTab: () => {
    // recordEventWrapper({
    //   event: 'event_PFM_on_click_event',
    //   category: 'PFM',
    //   action: 'Online Investments',
    //   label: 'Login - Landing Screen - mPIN',
    // });
  },
  onClickNetBankingTab: () => {
    // recordEventWrapper({
    //   event: 'event_PFM_on_page_load_vpv',
    //   page: 'vpv/pfm/online-investments/login/net-banking',
    //   title: 'PFM - Online Investments - Login - Net Banking',
    //   cd24: 'website',
    // });
    // recordEventWrapper({
    //   event: 'event_PFM_on_click_event',
    //   category: 'PFM',
    //   action: 'Online Investments',
    //   label: 'Login - Landing Screen - Net Banking',
    // });
  },
  onClickLogin: (pageName: string) => {
    // recordEventWrapper({
    //   event: 'event_PFM_on_click_event',
    //   category: 'PFM',
    //   action: 'Online Investments',
    //   label: `Login - Landing Screen - ${pageName} - Login`,
    // });
  },
});

export default login;
